import { action, computed, observable, makeObservable } from "mobx";
import { IAutocomplete } from "../../modelo/Autocomplete";
import Store from "../../store/Store";
import { Autotexto } from "../modelo/Autotexto";

class AutotextoStore extends Store {
    autotextos: Autotexto[] = [];
    autotextosFiltrado: Autotexto[] = [];
    autotextoParaEdicao: Autotexto;

    constructor() {
        super();
        makeObservable(this, {
            autotextos: observable,
            autotextosFiltrado: observable,
            autotextoParaEdicao: observable,
            resetAutotextos: action,
            optionsAutotextosNome: computed,
            optionsAutotextosDescricao: computed,
            optionsAutotextosTitulo: computed
        });
    }

    inicializar() {
        super.inicializar();
    }

    resetAutotextos = () => {
        this.autotextosFiltrado = this.autotextos;
    };

    get optionsAutotextosNome(): IAutocomplete<string>[] {
        return this.optionsAutotextosBy('nome');
    }

    get optionsAutotextosDescricao(): IAutocomplete<string>[] {
        return this.optionsAutotextosBy('descricao');
    }

    get optionsAutotextosTitulo(): IAutocomplete<string>[] {
        return this.optionsAutotextosBy('titulo', [
            'Fundamento',
            'Hipótese'
        ]);
    }

    optionsAutotextosBy(field, initials = []): IAutocomplete<string>[] {

        const options = new Array<IAutocomplete<string>>();
        const hasInitials = !!initials;
        if (hasInitials) {
            initials.forEach(initial => {
                const option = {
                    valor: initial,
                    texto: initial,
                    parametrosBusca: [initial]
                }
                options.push(option);
            });
        }
        this.autotextosFiltrado.forEach(autotexto => {
            const value = autotexto[field];
            if (!options.some(
                item => item.parametrosBusca[0] === value)) {
                if (!hasInitials || value) {
                    options.push({
                        valor: value,
                        texto: value,
                        parametrosBusca: [value]
                    })
                }
            }
        });
        return options;
    }
}

export default new AutotextoStore();

